/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Error_Zalo_Test_Phone_InvalidInputs */

const vi_error_zalo_test_phone_invalid = /** @type {(inputs: Error_Zalo_Test_Phone_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số điện thoại thứ ${i?.position} chưa đúng — nhập 10 số bắt đầu bằng 0.`)
};

/**

* @param {Error_Zalo_Test_Phone_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_test_phone_invalid = /** @type {((inputs: Error_Zalo_Test_Phone_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Test_Phone_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_test_phone_invalid(inputs)
});